import { makeApi } from '@zodios/core';
import { z } from 'zod';
import { 
  errors, 
  linkSchema, 
  createLinkSchema, 
  updateLinkSchema, 
  paginationSchema,
  linkListResponseSchema 
} from './schemas/common.schema';

const linkApi = makeApi([
  {
    method: 'get',
    path: '/v1/link',
    alias: 'listLinks',
    description: 'List links for authenticated tenant with pagination',
    parameters: [
      {
        name: 'query',
        type: 'Query',
        schema: paginationSchema,
      },
    ],
    response: linkListResponseSchema,
    errors,
  },
  {
    method: 'post',
    path: '/v1/link',
    alias: 'createLink',
    description: 'Create a new short link',
    parameters: [
      {
        name: 'body',
        type: 'Body',
        schema: createLinkSchema,
      },
    ],
    response: linkSchema,
    errors,
  },
  {
    method: 'get',
    path: '/v1/link/:shortCode',
    alias: 'getLink',
    description: 'Get a specific link by shortCode',
    parameters: [
      {
        name: 'shortCode',
        type: 'Path',
        schema: z.string().length(7),
      },
    ],
    response: linkSchema,
    errors,
  },
  {
    method: 'put',
    path: '/v1/link/:shortCode',
    alias: 'updateLink',
    description: 'Update an existing link',
    parameters: [
      {
        name: 'shortCode',
        type: 'Path',
        schema: z.string().length(7),
      },
      {
        name: 'body',
        type: 'Body',
        schema: updateLinkSchema,
      },
    ],
    response: z.object({ message: z.string() }),
    status: 204,
    errors,
  },
  {
    method: 'delete',
    path: '/v1/link/:shortCode',
    alias: 'deleteLink',
    description: 'Delete an existing link',
    parameters: [
      {
        name: 'shortCode',
        type: 'Path',
        schema: z.string().length(7),
      },
    ],
    response: z.object({ message: z.string() }),
    status: 204,
    errors,
  },
]);

export default linkApi;